import { render, staticRenderFns } from "./lazyblock_all_tags.vue?vue&type=template&id=42739014&scoped=true"
import script from "./lazyblock_all_tags.vue?vue&type=script&lang=js"
export * from "./lazyblock_all_tags.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_all_tags.vue?vue&type=style&index=0&id=42739014&prod&lang=scss&scoped=true"
import style1 from "./lazyblock_all_tags.vue?vue&type=style&index=1&id=42739014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42739014",
  null
  
)

export default component.exports